"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Checkbox_1 = __importDefault(require("@material-ui/core/Checkbox"));
const FormControlLabel_1 = __importDefault(require("@material-ui/core/FormControlLabel"));
const prop_types_1 = __importDefault(require("prop-types"));
const stopPropagation = (e) => {
    e.stopPropagation();
};
const Checkbox = ({ label, labelClasses, ...restProps }) => (react_1.default.createElement(FormControlLabel_1.default, { onClick: stopPropagation, classes: labelClasses, control: react_1.default.createElement(Checkbox_1.default, { ...restProps, onClick: stopPropagation }), label: label }));
Checkbox.defaultProps = {
    checked: false,
    label: '',
    labelClasses: undefined,
    color: 'default',
    disabled: false,
};
Checkbox.propTypes = {
    checked: prop_types_1.default.bool,
    label: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.element]),
    disabled: prop_types_1.default.bool,
    onChange: prop_types_1.default.func.isRequired,
    labelClasses: prop_types_1.default.object,
    color: prop_types_1.default.string,
};
exports.default = Checkbox;
//# sourceMappingURL=checkbox.js.map